import configData from '../../config.json';
import axios from 'axios';
import { Decrypt } from '../Helper';

export const GetStudent = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `Students/get`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const GetStudentsById = async (id) => {
    var config = {
        method: 'get',
        url: configData.API_ENDPOINT + `Students/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        // data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const UpdateStudents = async (v, id) => {
    var config = {
        method: 'put',
        url: configData.API_ENDPOINT + `Students/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}
export const CreateStudents = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `Students`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}
export const DeleteStudents = async (id) => {
    var config = {
        method: 'delete',
        url: configData.API_ENDPOINT + `Students/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        // data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}     

export const GetAllCollege = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `organizations/getcollege`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}